import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceCRUD } from './../../../shared/crud/ServiceCRUD';
import { environment } from '././../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BiCspuioService extends ServiceCRUD {
  private baseUrlService: string;  

  constructor(http: HttpClient, router: Router) {
    super(http, router);
    this.baseUrlService = environment.URL_API
  }

  protected getURL(): string {
    return `${this.baseUrlService}/cspuio`
  }
}
